import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {User} from '../../models/user';
import {MembershipService} from '../../services/membership.service';
import {finalize, Subject, takeUntil} from 'rxjs';
import {PasswordResetModalComponent} from './password-reset-modal/password-reset-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  loading = false;
  email: string = "";
  password: string = "";

  constructor(private router: Router,
              private route: ActivatedRoute,
              private modal: NgbModal,
              private authService: AuthService,
              private membershipService: MembershipService) {
  }

  ngOnInit() {
    this.authService.currentUser$.pipe(takeUntil(this.onDestroy$)).subscribe((currentUser) => {
      this.handleCurrentUser(currentUser)
    })
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  login() {
    this.loading = true;

    this.authService.login(this.email, this.password)
      .pipe(finalize(() => this.loading = false))
      .subscribe(() => {
        this.email = ""
        this.password = ""
      })
  }

  forgotPassword() {
    const passwordResetModal = this.modal.open(PasswordResetModalComponent, {centered: true})
    passwordResetModal.componentInstance.email = this.email;
  }

  handleCurrentUser(currentUser: User) {
    if (currentUser) {

      // Check to see if there is a redirect uri in the request parameter
      const redirect = this.route.snapshot.queryParamMap.get('redirect');
      if ((redirect && decodeURIComponent(redirect) !== '/login')) {
        this.router.navigateByUrl(redirect).finally()
        return;
      }

      // Redirect admin
      if (currentUser.role === 'admin') {
        window.location.href = "https://beta.getcroissant.com/admin/home"
        return;
      }

      // Redirect employee
      if (currentUser.role === 'employee') {
        window.location.href = "https://beta.getcroissant.com/admin/home"
        return;
      }

      // Redirect shareholder
      if (currentUser.role === 'shareholder') {
        this.router.navigate(['/shareholder', 'home']).finally()
        return;
      }

      // Redirect merchant
      if (currentUser.role === 'merchant') {
        this.router.navigate(['/partner']).finally()
        return;
      }

      // Redirect customer
      if (currentUser.role === 'customer') {

        // Check to see if customer has an active membership
        this.membershipService.getCurrentByUser().subscribe({

          // Active membership - forward to discover page
          next: () => this.router.navigate(['/discover']).finally(),

          // Inactive membership - forward to renewal page
          error: () => this.router.navigate(['/settings', 'membership']).finally()
        });

        return;
      }
    }
  }
}
